import { useColorMode } from '@vueuse/core'

export default function useTheme() {
  return useColorMode({
    storageKey: 'colour-mode',
  })
}
